import { AlertBox, Box, Button, FlexBox, Icon, Typography } from '@vp/swan';

export interface ChatErrorBannerProps {
    retryCount: number;
    onRetry: () => void;
    onReview?: () => void;
}

export function ChatErrorBanner({ retryCount, onRetry, onReview }: ChatErrorBannerProps) {
    const isPersistentError = retryCount >= 2;

    const errorMessage = isPersistentError
        ? "We're still having trouble sending your message."
        : "We couldn't send your message. Please try again.";

    return (
        <Box style={{ maxWidth: '768px', margin: '0 auto', padding: 'var(--swan-sem-space-6)' }}>
            <AlertBox skin="error" toast={false}>
                <FlexBox alignItems="center" justifyContent="space-between">
                    <Typography>{errorMessage}</Typography>
                    {!isPersistentError && (
                        <Button skin="link" iconPosition="left" onClick={onRetry}>
                            <Icon iconType="reset" size="small" mr="3" />
                            Try again
                        </Button>
                    )}
                    {isPersistentError && onReview && (
                        <Button skin="link" iconPosition="left" onClick={onReview}>
                            <Icon iconType="customQuote" size="small" mr="3" />
                            Review brief
                        </Button>
                    )}
                </FlexBox>
            </AlertBox>
        </Box>
    );
}
